import { action } from 'typesafe-actions';

import * as CONST from './consts';

export const setAppSelectedRestaurant = (restaurantId: string) =>
  action(CONST.SET_APP_SELECTED_RESTAURANT, { restaurantId });
export const setAppSelectedMenu = (menuId: string) => action(CONST.SET_APP_SELECTED_MENU, { menuId });
export const setAppSelectedCategory = (categoryId: string) => action(CONST.SET_APP_SELECTED_CATEGORY, { categoryId });
export const setAppSelectedDish = (dishId: string | null) => action(CONST.SET_APP_SELECTED_DISH, { dishId });
